import { render } from "./SupplierSpendReport.vue?vue&type=template&id=580b67e0"
import script from "./SupplierSpendReport.vue?vue&type=script&lang=js"
export * from "./SupplierSpendReport.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__